interface EmailPayload {
  to?: unknown;
  cc?: unknown;
  bcc?: unknown;
  subject?: unknown;
  body?: unknown;
}

export function formatEmailForClipboard(payload: EmailPayload): string {
  const lines: string[] = [];
  const subject = typeof payload.subject === 'string' ? payload.subject : '';
  const to = typeof payload.to === 'string' ? payload.to : '';
  const cc = typeof payload.cc === 'string' ? payload.cc : '';
  const bcc = typeof payload.bcc === 'string' ? payload.bcc : '';
  const body = typeof payload.body === 'string' ? payload.body : '';
  if (subject) lines.push(`Subject: ${subject}`);
  if (to) lines.push(`To: ${to}`);
  if (cc) lines.push(`Cc: ${cc}`);
  if (bcc) lines.push(`Bcc: ${bcc}`);
  if (lines.length) lines.push('');
  lines.push(body);
  return lines.join('\n');
}
